<template>
  <div class="payment-success">
    <van-loading v-if="loading" class="payment-success-loading" type="spinner" vertical>加载中...</van-loading>

    <template v-else>
      <!-- 顶部成功态 -->
      <div class="result">
        <div class="result-icon-wrap">
          <van-icon name="checked" class="result-icon" />
        </div>
        <div class="result-title">报名费支付成功</div>
        <div class="result-match">
          <img v-if="matchIconUrl" :src="matchIconUrl" alt="" class="result-match-icon" />
          <span class="result-match-text">{{ matchUnionName }}</span>
        </div>
      </div>

      <!-- 报名资料卡片：跳转报名单 -->
      <div class="card card-signup" @click="goToSignupSheet">
        <div class="card-main">
          <div class="logo" v-if="cardAvatarUrl" >
            <img :src="cardAvatarUrl" alt="" />
            <!-- <img v-else src="@/assets/player-default.png" alt="" /> -->
          </div>
          <div class="info">
            <div class="name">{{ cardTitleText }}</div>
            <div class="minor">{{ cardSubtitleText }}</div>
          </div>
        </div>
        <van-icon name="arrow" class="card-chevron" />
      </div>

      <!-- 赛事主页 -->
      <div class="next">
        <div class="next-left">
          <div class="next-title">去赛事主页</div>
          <div class="next-sub">了解最新比赛赛程·积分·公告</div>
        </div>
        <van-button round type="info" class="next-btn" @click.stop="goMatchHome">前往</van-button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, Button, Toast, Loading } from 'vant'
import { getBMMatchTeamSignup, getOrderDetail } from '@/api/match'
import { QNImageUtil } from '@/utils'
import { getPassport } from '@/libs/passport'

Vue.use(Icon).use(Button).use(Toast).use(Loading)

/** unitType：0 队伍 1 个人 2 组合 — 与 entry-list goEntryInfo 一致 */
export default {
  name: 'PaymentSuccess',
  data() {
    return {
      loading: true,
      unionMatchId: '',
      matchId: '',
      teamId: '',
      orderId: '',
      playerId: '',
      categoryHint: null,
      order: {},
      match: {},
      team: {},
      player: {}
    }
  },
  computed: {
    /** 优先订单详情，其次报名接口 match */
    resolvedUnitType() {
      const o = this.order || {}
      if (o.unitType != null && o.unitType !== '') return Number(o.unitType)
      const m = this.match || {}
      if (m.unitType != null && m.unitType !== '') return Number(m.unitType)
      return null
    },
    /** 与支付页 query.category 一致：0 队订单 1 队员订单 */
    effectiveCategory() {
      if (this.categoryHint != null && !Number.isNaN(Number(this.categoryHint))) {
        return Number(this.categoryHint)
      }
      return Number(this.match.unitType) === 1 ? 1 : 0
    },
    matchUnionName() {
      return (
        this.order.matchName ||
        this.match.unionMatchName ||
        this.match.chineseName ||
        '—'
      )
    },
    matchIconUrl() {
      const icon = this.match.icon
      return icon ? QNImageUtil.imageView(icon) : ''
    },
    cardTitleText() {
      const cat = this.effectiveCategory
      const u = this.resolvedUnitType
      if (cat === 1 || u === 1) {
        return this.player.trueName || this.order.playerName || '—'
      }
      return this.team.name || this.order.teamName || '—'
    },
    cardSubtitleText() {
      return (
        this.order.matchGroup ||
        this.match.group ||
        this.match.matchGroupName ||
        '—'
      )
    },
    cardAvatarUrl() {
      const cat = this.effectiveCategory
      const u = this.resolvedUnitType
      if (cat === 1 || u === 1) {
        const a = this.player.avatar
        return a ? QNImageUtil.imageView(a) : ''
      }
      const b = this.team.badge
      return b ? QNImageUtil.imageView(b) : ''
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.matchId = this.$route.query.matchId || ''
    this.teamId = this.$route.query.teamId || ''
    this.orderId = this.$route.query.orderId || ''
    this.playerId = this.$route.query.playerId || ''
    const cat = this.$route.query.category
    if (cat !== undefined && cat !== null && cat !== '') {
      this.categoryHint = Number(cat)
    }
    this.fetchAll()
  },
  methods: {
    async fetchAll() {
      if (!this.matchId || !this.teamId || !this.orderId) {
        this.loading = false
        Toast.fail('缺少必要参数')
        return
      }
      this.loading = true
      try {
        await getPassport()
        const signupRes = await getBMMatchTeamSignup({
          matchId: this.matchId,
          teamId: this.teamId
        })
        const data = (signupRes && signupRes.data) || {}
        this.match = data.match || {}
        this.team = data.team || {}
        const players = data.players || []
        if (this.playerId) {
          this.player =
            players.find(p => String(p.id) === String(this.playerId)) || {}
        } else {
          this.player = players[0] || {}
        }

        const category =
          this.categoryHint != null && !Number.isNaN(this.categoryHint)
            ? this.categoryHint
            : Number(this.match.unitType) === 1
              ? 1
              : 0

        const orderRes = await getOrderDetail({
          orderId: this.orderId,
          category
        })
        if (orderRes && orderRes.data) {
          this.order = orderRes.data
          if (this.order.userPayment != null && this.order.userPayment !== '') {
            this.order.userPayment = (Number(this.order.userPayment) / 100).toFixed(2)
          }
        }
      } catch (e) {
        Toast.fail((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    /**
     * 个人报名 unitType=1 → person-info；
     * 队伍/组合下队员独立付费订单（category=1 + playerId）→ entry-info-player（队员视角）；
     * 否则队伍/组合领队视角 → entry-info。
     */
    goToSignupSheet() {
      let u = this.resolvedUnitType
      if (u == null || Number.isNaN(Number(u))) {
        const m = Number(this.match.unitType)
        u = Number.isNaN(m) ? null : m
      } else {
        u = Number(u)
      }
      const category = this.effectiveCategory
      const q = {
        unionMatchId: this.unionMatchId,
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (u === 1) {
        this.$router.push({ path: '/entry-page/person-info', query: q })
        return
      }
      if (
        category === 1 &&
        this.playerId &&
        (u === 0 || u === 2)
      ) {
        this.$router.push({
          path: '/entry-page/entry-info-player',
          query: { ...q, playerId: this.playerId }
        })
        return
      }
      if (u === 0 || u === 2) {
        this.$router.push({ path: '/entry-page/entry-info', query: q })
      } else {
        Toast('无法识别报名类型')
      }
    },
    goMatchHome() {
      const unionMatchId =
        this.unionMatchId ||
        this.match.unionMatchId ||
        this.$route.query.unionMatchId ||
        ''
      if (unionMatchId) {
        this.$router.replace({
          name: 'MatchOverall',
          query: { unionMatchId }
        })
        return
      }
      this.$router.replace({ name: 'ApplyHome' })
    }
  }
}
</script>

<style scoped lang="scss">
.payment-success {
  min-height: 100vh;
  background: #f6f6f8;
  padding: 16px;
  box-sizing: border-box;
}

.payment-success-loading {
  padding: 80px 0;
}

.result {
  text-align: center;
  padding: 20px 12px 8px;

  .result-icon-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
  }

  .result-icon {
    font-size: 56px;
    color: #07c160;
  }

  .result-title {
    font-size: 18px;
    font-weight: 600;
    color: #1d2129;
    line-height: 26px;
  }

  .result-match {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 10px;
    padding: 0 8px;
  }

  .result-match-icon {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .result-match-text {
    font-size: 13px;
    color: #606266;
    line-height: 20px;
    text-align: left;
  }
}

.card-signup {
  margin-top: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 12px 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  &:active {
    opacity: 0.92;
  }

  .card-main {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }

  .logo {
    width: 52px;
    height: 52px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e8e8e8;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info {
    flex: 1;
    margin-left: 12px;
    min-width: 0;

    .name {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .minor {
      margin-top: 6px;
      font-size: 13px;
      color: #606266;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .card-chevron {
    flex-shrink: 0;
    color: #c0c4cc;
    font-size: 16px;
  }
}

.next {
  margin-top: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .next-left {
    flex: 1;
    min-width: 0;
  }

  .next-title {
    font-size: 15px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
  }

  .next-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #86909c;
    line-height: 18px;
  }

  .next-btn {
    width: 88px;
    height: 36px;
    flex-shrink: 0;
  }
}
</style>
